<template>
  <v-autocomplete
    v-model="selectedModelList"
    :items="modelList"
    clearable
    hide-no-data
    hide-selected
    return-object
    :loading="loading"
    item-value="id"
    item-text="title"
    label="Уровень блокировки"
    persistent-hint
    @change="onSelectedModelListChange"
  />
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'

export const BLACK_LIST_LEVEL_ORGANIZATION = 'organization'
export const BLACK_LIST_LEVEL_LEGAL_ENTITY_LEVEL = 'legal-entity'

export const BLACK_LIST_LEVEL_OFFICE = 'office'
export const BLACK_LIST_LEVEL_VACANCY = 'vacancy'
export const BLACK_LIST_LEVEL_SYSTEM = 'system'

export const BLACK_LIST_LEVEL_ORGANIZATION_LABEL = 'ЧС организации'
export const BLACK_LIST_LEVEL_LEGAL_ENTITY_LABEL = 'ЧС Юр. лица'
export const BLACK_LIST_LEVEL_OFFICE_LABEL = 'ЧС объекта'
export const BLACK_LIST_LEVEL_VACANCY_LABEL = 'Вакансия'
export const BLACK_LIST_LEVEL_SYSTEM_LABEL = 'Временная блокировка'

export const BLACK_LIST_LEVEL_SET = {
  BLACK_LIST_LEVEL_ORGANIZATION,
  BLACK_LIST_LEVEL_LEGAL_ENTITY_LEVEL,
  BLACK_LIST_LEVEL_OFFICE,
  BLACK_LIST_LEVEL_VACANCY,
  BLACK_LIST_LEVEL_SYSTEM,
}

export default {
  name: 'WBDBlackListLevelFilter',
  props: {
    remoteSelectedOption: {
      type: String,
    },
    remoteList: {
      type: Array,
    },
  },
  data () {
    return {
      loading: false,
      searchQuery: null,
      modelList: [
        {
          id: BLACK_LIST_LEVEL_OFFICE,
          title: BLACK_LIST_LEVEL_OFFICE_LABEL,
        },
        {
          id: BLACK_LIST_LEVEL_LEGAL_ENTITY_LEVEL,
          title: BLACK_LIST_LEVEL_LEGAL_ENTITY_LABEL,
        },
        // {
        //   id: BLACK_LIST_LEVEL_VACANCY,
        //   title: 'Вакансия',
        // },
        {
          id: BLACK_LIST_LEVEL_ORGANIZATION,
          title: BLACK_LIST_LEVEL_ORGANIZATION_LABEL,
        },
        {
          id: BLACK_LIST_LEVEL_SYSTEM,
          title: BLACK_LIST_LEVEL_SYSTEM_LABEL,
        },
      ],
      selectedModelList: null,
    }
  },
  computed: {
    ...mapGetters({
    }),
  },
  created () {
    if (this.remoteList && this.remoteList.length) {
      this.modelList = this.remoteList
      this.selectedModelList = this.remoteList[0]
    }
    this.eventsBus.$on(this.eventNames.BLACK_LIST_LEVEL_FILTER_RESET, () => {
      this.selectedModelList = null
      this.searchQuery = null
    })


    // this.selectedModelList = {
    //   id: BLACK_LIST_LEVEL_SYSTEM,
    //   title: BLACK_LIST_LEVEL_SYSTEM_LABEL,
    // }
  },
  methods: {
    ...mapMutations({
    }),
    ...mapActions({
    }),
    onSelectedModelListChange () {
      this.$emit(
        'onBlackListLevelStatusSelectorFilterChange',
        this.selectedModelList ? this.selectedModelList.id : null
      )
    },
  }
}
</script>
